import { CREATOR_QUESTS } from './creator/index';
import { EXPLORER_QUESTS } from './explorer/index';
import { SKILL_BUILDER_QUESTS } from './skill-builder/index';
import { TEAM_UP_QUESTS } from './team-up/index';

export const ALL_QUESTS = [
  ...CREATOR_QUESTS,
  ...EXPLORER_QUESTS,
  ...SKILL_BUILDER_QUESTS,
  ...TEAM_UP_QUESTS,
];
